import React, { useState, useEffect, useRef } from "react";
import "./FriendForm.scss";
import { FaTrash } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { toast } from "react-toastify";

const FriendForm = ({ onFriendsUpdate, playersReq }) => {
  const [bringingFriend, setBringingFriend] = useState(false);
  const [friends, setFriends] = useState([]);
  const prevValidFriends = useRef([]);

  const toggleBringingFriend = () => {
    if (!bringingFriend && playersReq <= 1) {
      toast.warn("Increase the number of players to bring a friend.");
      return;
    }

    setBringingFriend((prev) => !prev);
    if (!bringingFriend && friends.length === 0) {
      setFriends([{ id: Date.now(), name: "", contact: "" }]);
    } else if (bringingFriend) {
      setFriends([]);
    }
  };

  const addFriend = () => {
    if (friends.length >= playersReq - 1) {
      toast.warn(`You can only add up to ${playersReq - 1} friends.`);
      return;
    }
    setFriends([...friends, { id: Date.now(), name: "", contact: "" }]);
  };

  const removeFriend = (id) => {
    setFriends(friends.filter((friend) => friend.id !== id));
  };

  const handleInputChange = (id, field, value) => {
    setFriends(
      friends.map((friend) =>
        friend.id === id ? { ...friend, [field]: value } : friend
      )
    );
  };

  useEffect(() => {
    if (onFriendsUpdate) {
      const validFriends = friends.filter(
        (friend) => friend.name.trim() !== "" && friend.contact.trim() !== ""
      );

      const hasChanged =
        prevValidFriends.current.length !== validFriends.length ||
        validFriends.some(
          (friend, index) =>
            friend.name !== prevValidFriends.current[index]?.name ||
            friend.contact !== prevValidFriends.current[index]?.contact
        );

      if (
        hasChanged ||
        bringingFriend !== prevValidFriends.current.bringingFriend
      ) {
        onFriendsUpdate(validFriends, bringingFriend);
        prevValidFriends.current = validFriends;
        prevValidFriends.current.bringingFriend = bringingFriend;
      }
    }
  }, [friends, bringingFriend, onFriendsUpdate]);

  return (
    <div className="friend-form-container">
      <div className="header">
        <span className="title">BRINGING A FRIEND?</span>
        <div className="checkbox-container">
          <input
            type="checkbox"
            className="custom-checkbox"
            checked={bringingFriend}
            onChange={toggleBringingFriend}
            disabled={playersReq <= 1}
          />
        </div>
      </div>
      <p className="sub-text">
        (Provide correct details to avoid inconvenience at the Facility!)
      </p>
      {bringingFriend && (
        <div className="add-icon-container">
          <FiPlus className="add-icon" onClick={addFriend} />
        </div>
      )}
      {bringingFriend && (
        <div className="friends-list">
          {friends.map((friend) => (
            <div key={friend.id} className="friend-input-group">
              <input
                type="text"
                placeholder="Name"
                value={friend.name}
                onChange={(e) =>
                  handleInputChange(friend.id, "name", e.target.value)
                }
              />
              <input
                type="text"
                placeholder="Contact No"
                value={friend.contact}
                onChange={(e) =>
                  handleInputChange(friend.id, "contact", e.target.value)
                }
              />
              <FaTrash
                className="delete-icon"
                onClick={() => removeFriend(friend.id)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FriendForm;
